import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=3ee7bfd9&scoped=true&"
import script from "./DropArea.vue?vue&type=script&lang=js&"
export * from "./DropArea.vue?vue&type=script&lang=js&"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=3ee7bfd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7bfd9",
  null
  
)

export default component.exports